import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileBottomBar from "./components/MobileBottomBar";
import CookieBanner from "./components/CookieBanner";
import Home from "./pages/Home";
import StorePage from "./pages/StorePage";
import Servizi from "./pages/Servizi";
import ContoOnline from "./pages/ContoOnline";
import Guida from "./pages/Guida";
import Promozioni from "./pages/Promozioni";
import Contatti from "./pages/Contatti";
import LegalPage from "./pages/LegalPage";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (lenis) lenis.scrollTo(el, { offset: -90 });
        else el.scrollIntoView({ behavior: "smooth" });
      }, 120);
      return () => clearTimeout(t);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, lerp: 0.11 });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <main className="pb-[84px] md:pb-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mestre" element={<StorePage id="mestre" />} />
            <Route path="/padova" element={<StorePage id="padova" />} />
            <Route path="/santangelo" element={<StorePage id="santangelo" />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/conto-online" element={<ContoOnline />} />
            <Route path="/guida" element={<Guida />} />
            <Route path="/promozioni" element={<Promozioni />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy" element={<LegalPage pageKey="privacy" />} />
            <Route path="/cookie-policy" element={<LegalPage pageKey="cookie-policy" />} />
            <Route path="/gioco-responsabile" element={<LegalPage pageKey="gioco-responsabile" />} />
            <Route path="/note-legali" element={<LegalPage pageKey="note-legali" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <MobileBottomBar />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
